/**
 * Where gym switch should land from a Next.js pathname (the route pattern,
 * e.g. `/landing-pages/[id]`). Most sections truncate to the first segment.
 * `/landing-pages` has no index page, and `/forms` client-redirects to
 * `/pages` when that flag is on, so those map to a real list instead.
 */
export function sectionRootForPath(pathname: string, pagesEnabled: boolean): string {
  if (pathname === "/landing-pages" || pathname.startsWith("/landing-pages/")) {
    return "/pages";
  }
  if (pathname === "/forms" || pathname.startsWith("/forms/")) {
    return pagesEnabled ? "/pages" : "/forms";
  }
  return pathname.split("/").slice(0, 2).join("/");
}
